import React from 'react';
import { CountdownTimer } from './CountdownTimer';
import { trackAddToCart } from '../utils/pixel';
export function BuySection() {
  return <section id="comprar" className="py-20 bg-gradient-to-b from-[#111] to-black relative" data-id="element-30">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-amber-900/20 via-black to-black pointer-events-none" data-id="element-31"></div>

      <div className="max-w-4xl mx-auto px-5 md:px-8 relative z-10" data-id="element-32">
        <div className="text-center mb-12" data-id="element-33">
          <h2 className="text-3xl md:text-5xl font-poppins font-bold text-white mb-6" data-id="element-34">
            Comienza hoy a explorar tu mundo interior con una nueva mirada
          </h2>
          <p className="text-xl text-gray-400" data-id="element-35">
            Descarga hoy Libro de la Sabiduría y recibe también tus 3 bonos
            gratuitos.
          </p>
        </div>

        <div className="bg-white/5 border border-amber-500/30 rounded-3xl overflow-hidden shadow-[0_0_50px_rgba(245,158,11,0.1)] backdrop-blur-md" data-id="element-36">
          <div className="bg-gradient-to-r from-amber-600 to-amber-800 p-4 text-center" data-id="element-37">
            <p className="text-white font-bold font-poppins tracking-wider uppercase text-sm md:text-base animate-pulse" data-id="element-38">
              ¡Oferta especial por tiempo limitado!
            </p>
          </div>

          <div className="p-8 md:p-12" data-id="element-39">
            <div className="flex flex-col md:flex-row items-center gap-10 mb-10" data-id="element-40">
              <div className="w-full md:w-1/2" data-id="element-41">
                <img src="https://cdn.magicpatterns.com/uploads/fv76ueuXSXpHkTgRccYtrc/COVER.png" alt="Libro de la Sabiduría" className="w-full max-w-xs mx-auto rounded-xl shadow-2xl" data-id="element-42" />
              </div>

              <div className="w-full md:w-1/2 space-y-6" data-id="element-43">
                <h3 className="text-2xl font-poppins font-bold text-white text-center md:text-left" data-id="element-44">
                  Lo que te llevas hoy:
                </h3>
                <ul className="space-y-3" data-id="element-45">
                  <li className="flex items-start" data-id="element-46">
                    <span className="text-amber-500 mr-3" data-id="element-47">✓</span>
                    <span className="text-gray-300" data-id="element-48">
                      <strong className="text-white" data-id="element-49">
                        Libro de la Sabiduría
                      </strong>{' '}
                      (Valor: $29)
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-50">
                    <span className="text-amber-500 mr-3" data-id="element-51">✓</span>
                    <span className="text-gray-300" data-id="element-52">
                      <strong className="text-white" data-id="element-53">Bono 1:</strong> Activación
                      Interior (Gratis)
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-54">
                    <span className="text-amber-500 mr-3" data-id="element-55">✓</span>
                    <span className="text-gray-300" data-id="element-56">
                      <strong className="text-white" data-id="element-57">Bono 2:</strong> Diario de
                      Sabiduría (Gratis)
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-58">
                    <span className="text-amber-500 mr-3" data-id="element-59">✓</span>
                    <span className="text-gray-300" data-id="element-60">
                      <strong className="text-white" data-id="element-61">Bono 3:</strong> Mapa de
                      Chakras (Gratis)
                    </span>
                  </li>
                </ul>
              </div>
            </div>

            <div className="border-t border-white/10 pt-8 text-center" data-id="element-62">
              <div className="mb-6" data-id="element-63">
                <p className="text-gray-400 text-lg line-through mb-1" data-id="element-64">
                  Valor Normal: $29.00 USD
                </p>
                <div className="flex justify-center items-end gap-2" data-id="element-65">
                  <span className="text-5xl md:text-6xl font-poppins font-extrabold text-amber-500 drop-shadow-[0_0_10px_rgba(245,158,11,0.5)]" data-id="element-66">
                    $7.99
                  </span>
                  <span className="text-xl text-amber-500 font-bold pb-1" data-id="element-67">
                    USD
                  </span>
                </div>
              </div>

              <div className="mb-8" data-id="element-68">
                <p className="text-white text-sm uppercase tracking-widest mb-3 font-medium" data-id="element-69">
                  Esta oferta expira en:
                </p>
                <CountdownTimer data-id="element-70" />
              </div>

              <a href="https://pay.hotmart.com/U106598052T" onClick={trackAddToCart} className="block w-full bg-gradient-to-r from-amber-500 to-amber-700 hover:from-amber-400 hover:to-amber-600 text-black text-center font-poppins font-bold px-6 py-5 rounded-xl text-xl transition-all duration-300 shadow-[0_0_30px_rgba(245,158,11,0.5)] transform hover:scale-105 active:scale-95 uppercase tracking-wide" data-id="element-71">
                Quiero comenzar mi viaje interior
              </a>

              <div className="mt-6 flex items-center justify-center gap-4 text-gray-500 text-sm" data-id="element-72">
                <span className="flex items-center" data-id="element-73">
                  <span className="mr-1" data-id="element-74">🔒</span> Pago 100% Seguro
                </span>
                <span className="flex items-center" data-id="element-75">
                  <span className="mr-1" data-id="element-76">⚡</span> Acceso Inmediato
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}